import { toBoolOrNull } from '@utils/parse';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type {
    IAcceptTransfusionsFormValues,
    IAcceptTransfusionsModel,
    IAcceptTransfusionsSubmitResult,
} from '@/types/screening/accept-transfusions';

const ACCEPT_TRANSFUSIONS_ENDPOINT = '/api/register/accept-transfusions';

const defaultAcceptTransfusionsModel: IAcceptTransfusionsModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.AcceptTransfusions,
    willAcceptTransfusions: null,
};

export const useAcceptTransfusions = (registrationId: number, editKey: string) => {
    const url = `${ACCEPT_TRANSFUSIONS_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultAcceptTransfusionsModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<
        IAcceptTransfusionsFormValues,
        DashRegistrationStep,
        IAcceptTransfusionsSubmitResult
    >(
        url,
        (values) => ({
            willAcceptTransfusions: toBoolOrNull(values.willAcceptTransfusions),
        }),
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
